/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
/**
 * @param {FormQuestionFileUpload} question
 */
const fileUploadSchemaTransformer = (question) => {

    /**
     * @type {FormQuestionFileUpload}
     */
    const newQuestion = {
        ...question,
        value: [],
    }

    return newQuestion
}

export { fileUploadSchemaTransformer }
